import {css} from 'emotion'
import {Colors} from './..'
export const ContentLoaderStyle = (ready) => css({
  position: 'relative',
  '.content-loader': {
    position: 'fixed',
    top: 80,
    left: '0',
    width: 80,
    height: 80,
    textAlign: 'center',
    lineHeight: '80px',
    transition: 'opacity 400ms ease',
    opacity: ready ? 0 : 1,
    zIndex: 0,
  },
})


// WEBPACK FOOTER //
// ./src/styles/components/contentLoader.js